import { render, staticRenderFns } from "./Robot_strategy.vue?vue&type=template&id=f23550dc&scoped=true&"
import script from "./Robot_strategy.vue?vue&type=script&lang=js&"
export * from "./Robot_strategy.vue?vue&type=script&lang=js&"
import style0 from "./Robot_strategy.vue?vue&type=style&index=0&id=f23550dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23550dc",
  null
  
)

export default component.exports